import { launchError, launchSuccess } from "components/notifications";
import { useState } from "react";
import { useTranslation } from 'react-i18next';
import './userReferrals.css'
import SearchUser from "components/SearchUser/SearchUser";
import { searchUsers } from "services/fetchUsers";
import { deleteUserReferral, setUserReferral } from "services/userServices";

const REFERRAL_COLLAPSE_THRESHOLD = 30;

const UserReferrals = ({ userData, setUserData, user, id }) => {

  const { t } = useTranslation();

  const [referrals, setReferrals] = useState([]);
  const [selectedReferral, setSelectedReferral] = useState({})
  const [expanded, setExpanded] = useState(false)

  const handleSearchReferrals = async (search) => {
    if (search.length > 0) {
      try {
        const fetchedUsers = await searchUsers(user, search)
        setReferrals(fetchedUsers)
      } catch (e) {
        console.error(e)
      }
    } else {
      setReferrals([])
    }
  }

  const addReferral = async () => {
    try {
      if (selectedReferral.uuid) {
        await setUserReferral(user, selectedReferral.uuid, id);
        const referrals = [...userData.referred_users];
        referrals.push(selectedReferral)
        setUserData({ ...userData, referred_users: referrals });
        setSelectedReferral({});
        setReferrals([])
        launchSuccess(t('notifications.users.userById.add_referred.success'))
      }
    } catch (error) {
      launchError(t('notifications.users.userById.add_referred.error'))
    }
  }

  const removeReferred = async (user_uuid) => {
    try {
      await deleteUserReferral(user, user_uuid);
      const referred = [...userData.referred_users];
      const index = referred.findIndex(({ uuid }) => uuid === user_uuid)
      referred.splice(index, 1);
      setUserData({ ...userData, referred_users: referred });
      launchSuccess(t('notifications.users.userById.remove_referred.success'))
    } catch (error) {
      launchError(t('notifications.users.userById.remove_referred.error'))
    }
  }

  const totalReferrals = userData.referred_users?.length ?? 0;
  const shouldCollapse = totalReferrals > REFERRAL_COLLAPSE_THRESHOLD;
  const displayedUsers = shouldCollapse && !expanded
    ? userData.referred_users.slice(0, REFERRAL_COLLAPSE_THRESHOLD)
    : userData.referred_users;

  return <div className='user_referrals_case'>
    <p className='user_referrals_title'>Filleuls : <span className='user_referrals_count'>{totalReferrals}</span></p>
    <div className='user_row_space_between_box'>
      <SearchUser
        id='search_user_input'
        selectUser={setSelectedReferral}
        selectedUser={selectedReferral}
        users={referrals}
        handleSearch={handleSearchReferrals}
        label={'Rechercher un parrain'}
      />
      <button className='user_action_button' onClick={addReferral} disabled={!selectedReferral.uuid}>Ajouter</button>
    </div>
    <p className='user_referrals_subtitle'>Liste des filleuls :</p>
    <div className='user_referrals_grid'>
      {displayedUsers.map(({ uuid, firstName, lastName, email }) =>
        (<div key={uuid} className='user_referral_item'>
          <span className='user_referral_name'>{firstName} {lastName}</span>
          <span className='user_referral_email'>{email}</span>
          <button className='user_referral_delete_user_button' onClick={() => removeReferred(uuid)}>X</button>
        </div>)
      )}
    </div>
    {shouldCollapse && (
      <button className='user_referrals_toggle' onClick={() => setExpanded(!expanded)}>
        {expanded ? 'Voir moins' : `Voir tout (${totalReferrals})`}
      </button>
    )}
  </div>
}

export default UserReferrals
